export default "__VITE_ASSET__YgGgO2UV__"